export const TABS = {
  GENERAL: "general",
  SUBSCRIPTION: "subscription"
};

export const PAGE_TITLE = "Account settings";
